import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: '1',
  title: 'Mi Diario de Manifestación',
  image: 'https://cdn.magicpatterns.com/uploads/g6A32XwKE15AMtHawVWRz9/Hand_writing_journal_gold_font_202607261452.jpg',
  desc: 'Aprende a cultivar tus sueños diariamente en un espacio íntimo y mágico que te conectará con tu poder interior. Cada día se convierte en una oportunidad de manifestar con precisión.',
  bullets: ['Rituales matutinos para sintonizar tu vibración.', 'Plantillas diarias para anclar tu intención con claridad.', 'Ejercicios de gratitud que activan la abundancia.'],
  value: '$17.00 USD'
}, {
  number: '2',
  title: 'Los Secretos de los Sonidos Mágicos',
  image: 'https://cdn.magicpatterns.com/uploads/7bUJeaoMmYSmATmnZykZjr/Smartphone_with_headphones_on_desk_202607261505.jpg',
  desc: 'Descubre cómo ciertos sonidos pueden abrir puertas a nuevas posibilidades. Aprende a usar frecuencias para transformar tu realidad y manifestar tus sueños más profundos mientras descansas.',
  bullets: ['Descubre la magia de los cuencos tibetanos.', 'Sonidos binaurales para estados de alfa profundo en minutos.', 'Protocolos de audio para escuchar antes de dormir.'],
  value: '$19.00 USD'
}, {
  number: '3',
  title: 'Números Mágicos para una Vida Abundante',
  image: 'https://cdn.magicpatterns.com/uploads/toKuaonVy6SXRKLhc9jtnX/Book_and_smartphone_mockup_2K_202607261505.jpg',
  desc: 'Domina el poder de los códigos sagrados y la numerología para activar energías de abundancia, superación y transformación usando simples secuencias numéricas.',
  bullets: ['El lenguaje secreto de los números.', 'La numerología y el dinero.', 'Protocolos de uso diario para sintonizar con la frecuencia correcta.'],
  value: '$27.00 USD'
}];
export function BonusesSection() {
  return <section className="py-20 bg-gradient-to-b from-[#0D1220] to-secondary relative" id="bonos" data-id="element-52" data-mp="109w5tck3gs9i">
      <div className="absolute -top-[100px] left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse,rgba(212,175,55,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-53" data-mp="alqqog5vbdw9" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-54" data-mp="kbtu7aam8a8u">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-55" data-mp="fjs8yyvgz96o">
          <div className="inline-block bg-gradient-to-br from-gold/15 to-gold/5 border border-gold/30 rounded-full px-6 py-2 text-[13px] font-bold text-gold tracking-[0.1em] uppercase mb-5" data-id="element-56" data-mp="od5bmsjc5p5y">
            🎁 Además, quiero darte 3 regalos especiales GRATIS
          </div>
          <h2 className="font-display text-3xl md:text-[44px] font-bold leading-[1.2] text-white" data-id="element-57" data-mp="y8yxx3muwx0x">
            Tres herramientas que <span className="text-gold" data-id="element-58" data-mp="302g380nillsi">aceleran</span> tu transformación
          </h2>
          <p className="mt-4 text-[17px] text-gray-400 max-w-[560px] mx-auto" data-id="element-59" data-mp="1fk5ja5u73rpr">
            Diseñados para complementar el sistema principal y eliminar las excusas que podrían frenarte.
          </p>
        </motion.div>

        <div className="flex flex-col gap-8 max-w-[880px] mx-auto" data-id="element-60" data-mp="15uuf8xm61d8q">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-6 md:gap-10 items-center bg-card border border-gold/15 rounded-[32px] p-7 md:p-9 relative overflow-hidden hover:border-gold/30 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)] transition-all group" data-id="element-61" data-mp="1asnh5egfrl37" data-mpi={i}>
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-gold via-violet to-transparent" data-id="element-62" data-mp="2ha0x02us4nph" />
              <div className="absolute top-5 right-6 font-display text-[72px] font-black text-gold/5 leading-none select-none pointer-events-none" data-id="element-63" data-mp="2m6hsji4b64cl">
                {bonus.number}
              </div>

              {/* Image Mockup */}
              <div className="relative flex items-center justify-center md:justify-start w-full" data-id="element-64" data-mp="d54zgqi7hmf5">
                <div className="w-full max-w-[240px] rounded-xl overflow-hidden border border-gold/20 shadow-lg" data-id="element-65" data-mp="8737th6pses2">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-cover aspect-[3/4]" data-id="element-66" data-mp="38ihc9h9l9gt" />
                </div>
              </div>

              {/* Contenido */}
              <div className="relative z-10" data-id="element-67" data-mp="3llg7joo98nxs">
                <span className="inline-block text-[11px] font-bold tracking-[0.12em] uppercase text-gold bg-gold/10 border border-gold/20 rounded-full px-3 py-1 mb-3" data-id="element-68" data-mp="3lmrbpplm3xpf">
                  🎁 BONO ESPECIAL #{bonus.number}
                </span>
                <h3 className="font-display text-xl md:text-[22px] font-bold text-white mb-3 leading-[1.3]" data-id="element-69" data-mp="1r5857mzrbrac">
                  "{bonus.title}"
                </h3>
                <p className="text-[15px] text-gray-400 leading-[1.7] mb-5" data-id="element-70" data-mp="1w2rjgmwgg42a">
                  {bonus.desc}
                </p>
                
                <div className="flex flex-col gap-2 mb-5" data-id="element-71" data-mp="254r0vgbdta5r">
                  {bonus.bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-2.5 text-sm text-gray-400" data-id="element-72" data-mp="18fjde2r7cqz7" data-mpi={idx}>
                      <span className="text-gold text-[10px] mt-1 shrink-0" data-id="element-73" data-mp="1ddbgzu17m1j8">✦</span>
                      {bullet}
                    </div>)}
                </div>

                <div className="flex items-center gap-3" data-id="element-74" data-mp="1m5wky406m3o0">
                  <span className="text-base text-gray-500 line-through" data-id="element-75" data-mp="1m7g1zwtnwiqu">Valor: {bonus.value}</span>
                  <span className="text-[15px] font-extrabold text-success bg-success/10 border border-success/25 rounded-full px-3.5 py-1" data-id="element-76" data-mp="po0b5y505gy8">
                    ¡HOY GRATIS!
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}